var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.9.8a.9.9 0 0 0-.9.9v.9h-.9A1.8 1.8 0 0 0 .3 4.4v9a1.8 1.8 0 0 0 1.8 1.8h10.8a1.8 1.8 0 0 0 1.8-1.8v-9a1.8 1.8 0 0 0-1.8-1.8H12v-.9a.9.9 0 1 0-1.8 0v.9H4.8v-.9a.9.9 0 0 0-.9-.9zm0 4.5a.9.9 0 0 0 0 1.8h7.2a.9.9 0 1 0 0-1.8z",
    fill: "#4318ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.bf4cda70ed9eacfc3f640379880a34fb.svg";
export { ForwardRef as ReactComponent };